// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JobForm_wrapper__tKlGD","describe-wrapper":"JobForm_describe-wrapper__anZxU"};